import { elakayAutoText } from "../../pageInside/dataElakay";

// Backend error codes of PATCH /user/profile -> translated message.
export const profileErrorMessage = (error) => {
  switch (error?.code) {
    case "NAME_REQUIRED":
      return elakayAutoText("h_prf_nameRequired", "First name and last name are required.");
    case "NAME_TOO_LONG":
      return elakayAutoText("h_prf_nameTooLong", "Names can have at most 80 characters.");
    case "UNSUPPORTED_LANGUAGE":
      return elakayAutoText("h_prf_unsupportedLanguage", "This language is not supported.");
    default:
      return elakayAutoText("h_prf_saveError", "Unable to save your changes. Please try again.");
  }
};
